<template>
    <div class="security-band">
        <div class="security-left">
            <img src="@/assets/images/footer/ssl-secure.png" alt="SSL" height="24" />
            <img src="@/assets/images/footer/3d-secure.png" alt="3D Secure" height="24" />
            <span style="width: 1px; height: 18px; background: #cbd5e1; margin: 0 0.375rem"></span>
            <img src="@/assets/images/footer/visa-logo.png" alt="Visa" height="15" />
            <img src="@/assets/images/footer/mastercard-logo.png" alt="Mastercard" height="15" />
        </div>
        <div class="security-center">
            <feather-icon icon="LockIcon" size="14" />
            <span>Bu işlem 256-bit SSL şifreleme yöntemiyle korunmaktadır. Kart bilgileriniz kayıt edilmez ve 3. şahıslarla paylaşılmaz.</span>
        </div>
        <div class="security-right">
            <b-link :to="{ name: 'privacy-policy' }">
                <feather-icon icon="FileTextIcon" size="12" />
                Gizlilik Politikası
            </b-link>
        </div>
    </div>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
    name: "SecurityBand",
    components: { BLink },
};
</script>

<style lang="scss" scoped>
.security-band {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.625rem 1rem;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    border-radius: 0 0 0.428rem 0.428rem;

    .dark-layout & {
        background: rgba(255, 255, 255, 0.03);
        border-top-color: #3b4253;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0.5rem;
        text-align: center;
    }
}

.security-left {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;

    img {
        height: 24px;
        opacity: 0.9;

        .dark-layout & {
            filter: brightness(1.1);
        }
    }
}

.security-center {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    color: #64748b;
    line-height: 1.4;

    .dark-layout & {
        color: #8a8ea0;
    }

    svg {
        color: #22c55e;
        flex-shrink: 0;

        .dark-layout & {
            color: #4ade80;
        }
    }

    @media (max-width: 576px) {
        text-align: center;

        svg {
            display: none;
        }
    }
}

.security-right {
    flex-shrink: 0;

    a {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        font-size: 0.75rem;
        font-weight: 500;
        color: #08a1ae;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }

        .dark-layout & {
            color: #28c4d4;
        }
    }
}
</style>
